webpackJsonp([9],{

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Page = __webpack_require__(535);

var _Page2 = _interopRequireDefault(_Page);

var _Head = __webpack_require__(180);

var _Head2 = _interopRequireDefault(_Head);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
exports.default = function () {
    return _react2.default.createElement(
        _Page2.default,
        null,
        _react2.default.createElement(_Head2.default, {
            title: '404 - Sorry, we\u2019ve searched the Ward and nothing turned up!',
            description: '404 - Not found. Sorry, we\u2019ve searched the Ward and nothing turned up!'
        }),
        _react2.default.createElement(
            'section',
            null,
            _react2.default.createElement(
                'div',
                { className: 'section__block', 'data-lateral': ' ' },
                _react2.default.createElement(
                    'div',
                    { className: 'container' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        '404 - Sorry, we\u2019ve searched the Ward and nothing turned up!'
                    )
                )
            )
        )
    );
};

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var children = _ref.children,
        pageClass = _ref.pageClass;

    return _react2.default.createElement(
        'div',
        { className: 'page ' + (pageClass ? pageClass : '') },
        children
    );
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/404.27ed25d8.js